import type { ProjectSettings, ScenarioSettings } from "models";

/** Project settings a new SoilSight project starts with. */
export const DEFAULT_PROJECT_SETTINGS: ProjectSettings = {
  forecastControls: { marketPriceTrend: 0, costDevelopment: 0 },
  location: { fieldSelect: null },
  variableCosts: { machineryDiesel: null },
  modelSettings: { climateImpact: true, rothCModel: true, silverServiceVersion: null },
};

/** Forecast settings a new project starts with: no trends, a 10-year timeline. */
export const DEFAULT_SCENARIO_SETTINGS: ScenarioSettings = {
  market: 0,
  costs: 0,
  timeline: 10,
};
